import React from 'react';
const Caption = ({
    children
}) => {
    return (
        <p className="text-caption">{children}</p>
    )
}
export default Caption;